import { useSyncExternalStore } from "react";

/**
 * rc136 — ¿Estamos en pantalla móvil (<md, 768px)?
 *
 * Mismo corte que Tailwind `md:` para que lo que decide JS (tabla vs
 * tarjetas, drawer vs página) coincida con lo que decide CSS.
 * Lee matchMedia y se suscribe a sus cambios (rotar el teléfono, redimensionar).
 */
const QUERY = "(max-width: 767.98px)";

function subscribe(cb: () => void) {
  const mq = window.matchMedia(QUERY);
  mq.addEventListener("change", cb);
  return () => mq.removeEventListener("change", cb);
}

export function useIsMobile(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(QUERY).matches,
    () => false,
  );
}
